// Fetch list

export const FETCH = 'reportVehiclePerformance.FETCH'
export const FETCH_STARTED = 'reportVehiclePerformance.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportVehiclePerformance.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportVehiclePerformance.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportVehiclePerformance.FETCH_CANCELLED'

// Clear

export const CLEAR = 'reportVehiclePerformance.CLEAR'

// Export

export const EXPORT = 'reportVehiclePerformance.EXPORT'
export const EXPORT_FULFILLED = 'reportVehiclePerformance.EXPORT_FULFILLED'

// Fetch details

export const FETCH_DETAILS = 'reportVehiclePerformance.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportVehiclePerformance.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportVehiclePerformance.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportVehiclePerformance.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportVehiclePerformance.FETCH_DETAILS_CANCELLED'

// Clear details

export const CLEAR_DETAILS = 'reportVehiclePerformance.CLEAR_DETAILS'

// Export details

export const EXPORT_DETAILS = 'reportVehiclePerformance.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportVehiclePerformance.EXPORT_DETAILS_FULFILLED'
